<template>
    <div class="card">
        <div class="card card-custom" >
          <div class="card-header flex-wrap border-0 pt-6 pb-0">
            <div class="card-title">
              <h3 class="card-label">{{ $t('setting.smtp') }}</h3>
            </div>
          </div>
          <form @submit.prevent="submitForm" class="form">
            <div class="modal-content">
              <div class="modal-body">
                <RequiredText />
                <div class="row">
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`${id}-host`"
                      type="text"
                      :label="$t('setting.smtp_host')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.smtp_host')"
                      v-model="formData.host"
                  />
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`${id}-port`"
                      type="number"
                      :min="0"
                      :label="$t('setting.smtp_port')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.smtp_port')"
                      v-model="formData.port"

                  />
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`${id}-username`"
                      type="text"
                      :label="$t('setting.smtp_username')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.smtp_username')"
                      v-model="formData.name"

                  />
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`${id}-password`"
                      type="password"
                      :label="$t('setting.smtp_pass')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.smtp_pass')"
                      v-model="formData.password"

                  />
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`${id}-mail`"
                      type="email"
                      :label="$t('setting.smtp_mail')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.smtp_mail')"
                      v-model="formData.email"

                  />
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`${id}-username`"
                      type="text"
                      :label="$t('setting.smtp_expe')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.smtp_expe')"
                      v-model="formData.username"

                  />
                </div>
              </div>
              <div class="modal-footer">
                <Button v-if="$can(abilities.EMAIL_CONFIG_CREATE)" btn-class="btn-sm me-3" type="new" id="submit_btn" btn-text="button.save" size="7px 30px" @click="createSmtp" :is-loading="processing"></Button>
              </div>
            </div>
          </form>
        </div>
      </div>
  </template>
  
<script setup>
  /* eslint-disable */
import {computed, onMounted, ref,watch} from "vue";
import Input from "@/components/Input.vue";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button"
import i18n from '@/plugins/i18n';
import {useStore} from "vuex";
import abilities from "@/composables/abilities";

const store = useStore()
const processing = ref(false)
const formData = ref({
  id: null,
  host: '',
  port: '',
  name: '',
  password: '',
  email: '',
  username: '',
})
  
const smtp = computed(() => store.getters['smtp/getSmtpConfiguration'])

function loadSmtp(){
  store.dispatch('smtp/loadSmtp')
};
  
function createSmtp() {
  processing.value = true
  store.dispatch('smtp/storeSmtp', formData.value)
      .then(res => {
        window.toastr['success'](i18n.global.t("notification.config_success"))
        loadSmtp()
      })
      .catch(err => {
      })
      .finally(() => processing.value = false)
}

watch(() => smtp.value, (value) => {

  let smtpConfig = smtp.value[0];
  formData.value = {
    id: null,
    host: smtpConfig?.host || '',
    port: smtpConfig?.port || '',
    name: smtpConfig?.name || '',
    password: '', 
    email: smtpConfig?.email || '',
    username: smtpConfig?.username || '',
  };
});

onMounted(() => {
  loadSmtp()
})
</script>
  
  
  